export default __webpack_public_path__ + "static/media/home-image-four.1da682c8.jpeg";